module.exports = __webpack_public_path__ + "static/media/USPHome.1ef55e92.png";